import { Box, styled } from "@material-ui/core";
import { Title2 } from "components/design-system/atoms/Typography";
import Body from "components/design-system/atoms/Typography/Body";
import { FC } from "react";

const TurquoiseTitle2 = styled(Title2)(({ theme }) => ({
  color: theme.palette.turquoise.main,
  fontSize: 21,
  marginBottom: "10px",
}));

const BodyWithLineHeight = styled(Body)({
  lineHeight: "140%",
  fontSize: "18px",
});

const Li = styled("li")({
  marginBottom: "8px",
});

const BoldText = styled("span")({
  fontWeight: 600,
});

const AsciiIcon: FC<{ ascii }> = ({ ascii, ...props }) => {
  return (
    <span role="img" style={{ marginRight: "8px" }} {...props}>
      {ascii}
    </span>
  );
};

const DrawerWrapper = styled(Box)(({ theme }) => ({
  margin: "24px 8px 24px 8px",
  [theme.breakpoints.down("md")]: {
    margin: "16px 8px 16px 8px",
  },
}));

const BorderBottomBox = styled(Box)({
  borderBottom: "1px solid rgba(219, 223, 232, 0.6)",
});

export default function LocalOfferDrawerContent() {
  return (
    <DrawerWrapper>
      <BorderBottomBox pb={5}>
        <Box>
          <Body color="secondary" style={{ fontSize: "18px" }}>
            <TurquoiseTitle2>Pourquoi un appareil de votre région ? </TurquoiseTitle2>
            Choisir un appareil proche de chez vous c&apos;est :
            <BoldText>
              <ul style={{ marginBottom: "0" }}>
                <Li>
                  <AsciiIcon aria-label="Emojis coche" ascii="&#9989;"></AsciiIcon>
                  Plus économique
                </Li>
                <Li>
                  <AsciiIcon aria-label="Emojis coche" ascii="&#9989;"></AsciiIcon>
                  Chez vous en 48h ou retrait dès le lendemain en atelier
                </Li>
                <Li>
                  <AsciiIcon aria-label="Emojis coche" ascii="&#9989;"></AsciiIcon>
                  Favorise l’emploi local
                </Li>
              </ul>
            </BoldText>
          </Body>
        </Box>
      </BorderBottomBox>
      <Box mt={5}>
        <TurquoiseTitle2> Plus proche, donc moins cher </TurquoiseTitle2>
        <Box>
          <BodyWithLineHeight color="secondary">
            Si l&apos;appareil est déjà près de chez vous, le trajet entre votre domicile et notre atelier n&apos;en
            sera que plus court ! C&apos;est mieux pour la planète et plus économique pour vous !{" "}
            <BoldText>Et avec le retrait en atelier, c&apos;est même 100% gratuit.</BoldText>
          </BodyWithLineHeight>
        </Box>
      </Box>
      <Box mt={5}>
        <TurquoiseTitle2> Plus proche, donc plus rapide </TurquoiseTitle2>
        <Box>
          <BodyWithLineHeight color="secondary">
            Choisir d&apos;acheter des appareils dans votre région, c&apos;est dire stop aux kilomètres inutiles. Au
            lieu de traverser la France, votre appareil n&apos;aura peut-être qu&apos;à traverser la rue pour rejoindre
            son nouveau foyer. C&apos;est pour ça qu&apos;on assure votre
            <BoldText> livraison en 48h top chrono !</BoldText>
          </BodyWithLineHeight>
        </Box>
      </Box>
      <Box mt={5}>
        <TurquoiseTitle2> Encore plus rapide : le retrait en atelier </TurquoiseTitle2>
        <Box>
          <BodyWithLineHeight color="secondary">
            Vous êtes dans les régions de Nantes, Lille, Paris ou Lyon ? Optez pour le retrait gratuit directement dans
            nos ateliers et repartez avec votre appareil <BoldText>dès le lendemain de votre commande !</BoldText> Plus
            rapide que ça, impossible.
          </BodyWithLineHeight>
        </Box>
      </Box>
      <Box mt={5}>
        <TurquoiseTitle2> Plus proche, donc plus d&apos;emplois de votre région </TurquoiseTitle2>
        <Box>
          <BodyWithLineHeight color="secondary">
            Pour vous proposer des appareils régionaux, on a fait appel à
            <BoldText> de vrais gens du coin très doués de leurs mains.</BoldText> Ces réparateurs travaillent près de
            chez eux et peut-être près de chez vous. Maintenir et défendre ces emplois locaux, c&apos;est faire rimer
            qualité et proximité !
          </BodyWithLineHeight>
        </Box>
      </Box>
    </DrawerWrapper>
  );
}
